module.exports = __webpack_public_path__ + "static/media/4.3128953f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/4.svg
// module id = 149
// module chunks = 0